import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AddOutlined, DeleteOutline, EditOutlined, Send, SendOutlined } from '@mui/icons-material';
import { CustomButton, TableData } from '../../../components';
import { confirmAlert, errorAlert } from '../../../helpers/alerts';
import { getEmailReportsService, removeEmailReportService, sendEmailReportService } from '../../../services/report/emailReportService';
import { removeEmailReport, setCurrentEmailReport, setEmailReports } from '../../../redux/slices/report/emailReportSlice';
import Images from 'assets/images';
import Image from 'components/common/Image';
import { setLoading } from 'redux/slices/uiSlice';
import { Box } from '@mui/material';
const ranges = {
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual'
}

const types = {
  balance: 'Saldos',
  movements: 'Movimientos',
}
const EmailReportScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { emailReports } = useSelector(store => store.emailReport);

  useEffect(() => {
    getEmailReportsService()
      .then((response) => dispatch(setEmailReports(response)))
      .catch((e) => errorAlert(e))
    // eslint-disable-next-line
  }, []);

  const handlerAdd = () => {
    navigate("crear");
  };

  const handlerEdit = (data) => {
    dispatch(setCurrentEmailReport(data));
    navigate("editar");
  };

  const handlerDelete = ({ id, hoster }) => {
    confirmAlert({
      title: "Estás seguro que deseas eliminar este reporte por correo?",
      text: `El reporte por correo de ${hoster?.username || "-"} será eliminado.`,
      onConfirm: async () => {
        removeEmailReportService(id)
          .then(() => dispatch(removeEmailReport(id)))
          .catch((e) => errorAlert(e))
      }
    })
  };

  const handlerHistory = (data) => {
    dispatch(setCurrentEmailReport(data));
    navigate(`historial`);
  };

  const handlerSend = (data) => {
    dispatch(setLoading(true))
    sendEmailReportService(data.id)
      .then(() => {
        confirmAlert({
          icon: "success",
          title: "Reporte Enviado",
          text: `Se ha enviado el reporte exitosamente al correo(s) registrado(s).`,
          showCancelButton: false,
        })
      })
      .catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)))
  };


  return (
    <Box mt={2}>
      <TableData
        dataRows={emailReports}
        headerButtons={[
          <CustomButton
            dark={true}
            icon={<AddOutlined />}
            key={'addEmailReport'}
            name={"Reporte por correo"}
            click={handlerAdd}
          />
        ].filter(Boolean)}
        dataTitle={[
          "Grupo/Commercio",
          "Frecuencia",
          "Tipo",
          "Correos electrónicos"
        ]}
        formatter={({ group, hoster, range, type, emails }) => [
          group?.name || hoster?.username || "-",
          range in ranges ? ranges[range] : "-",
          type in types ? types[type] : "-",
          {
            type: "text",
            value: (emails?.length ? emails?.join(" ") : "") || "-",
            maxWidth: 100
          },
        ]}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => {
              handlerEdit(data);
            },
          },
          {
            label: "Eliminar",
            icon: <DeleteOutline />,
            onClick: (data) => {
              handlerDelete(data);
            },
          },
          {
            label: "Enviar",
            icon: <SendOutlined />,
            onClick: (data) => {
              handlerSend(data);
            }
          },
          {
            label: "Historial",
            icon: <Image src={Images.icon.actions} alt="historial" />,
            onClick: (data) => handlerHistory(data)
          },
        ]}
      />
    </Box>
  )
}

export default EmailReportScreen